/**
 * Minimal synchronous Storage-compatible driver contract for P-1 persistence.
 *
 * @typedef {object} SyncStorageDriver
 * @property {(key: string) => string | null} getItem
 * @property {(key: string, value: string) => void} setItem
 * @property {(key: string) => void} removeItem
 */

/**
 * @param {unknown} driver
 * @returns {driver is SyncStorageDriver}
 */
export function isSyncStorageDriver(driver) {
  return (
    driver != null &&
    typeof driver.getItem === 'function' &&
    typeof driver.setItem === 'function' &&
    typeof driver.removeItem === 'function'
  );
}
